import React from 'react';
import { v4 as uuidV4 } from 'uuid';
import { FormattedMessage } from 'react-intl';

export const getCountryOptions = options =>
  options?.map(option => ({
    label: <FormattedMessage id={`COUNTRY_${option.code3}`} />,
    value: option.code3,
  })) || [];

export const formFieldNames = {
  NAME_KEY: 'name',
  STATUS_KEY: 'status',
  LANGUAGE_KEY: 'language',
  TIMEZONE_KEY: 'timezone',
  ADDRESS1_KEY: 'address1',
  ADDRESS2_KEY: 'address2',
  CITY_KEY: 'city',
  STATE_KEY: 'state',
  COUNTRY_KEY: 'country',
  POSTAL_CODE_KEY: 'postalCode',
  LATITUDE_KEY: 'latitude',
  LONGITUDE_KEY: 'longitude',
};

export const getNewSiteConfig = () => {
  return {
    status: 'ACTIVE',
    id: uuidV4(),
  };
};

export const getCompleteAddress = site => {
  const { address1, address2, city, state, postalCode } = site;
  let address = '';
  if (address1) {
    address = `${address + address1} `;
  }
  if (address2) {
    address = `${address + address2} `;
  }
  if (city) {
    address = `${address + city} `;
  }
  if (state) {
    address = `${address + state} `;
  }
  if (postalCode) {
    address = `${address + postalCode} `;
  }

  return address;
};

export const isSiteListPage = pathname => pathname.includes(`SitesPlace:sites`);
